import {
  AlertProvider,
  ToastProvider,
  TooltipProvider
} from "@prismicio/editor-ui"
import { createBrowserRouter, RouterProvider } from "react-router-dom"

import { AppErrorHandler } from "./components/AppErrorHandler"
import { AppSuspense } from "./components/AppSuspense"
import { AppThemeProvider, QueryProvider } from "./components/providers"
import { AmplitudeExperiments } from "./integrations/AmplitudeExperiments"
import { Intercom } from "./integrations/intercom"
import { getRouterBasename, routes } from "./routing"
import { preloadRepositoryCustomTypes } from "./services/customTypes"

export function App() {
  preloadRepositoryCustomTypes()

  return (
    <AppThemeProvider>
      <QueryProvider>
        <AppErrorHandler>
          <AppSuspense>
            <AlertProvider>
              <ToastProvider>
                <TooltipProvider>
                  <Intercom>
                    <AmplitudeExperiments>
                      <RouterProvider
                        router={router}
                        future={{ v7_startTransition: true }}
                      />
                    </AmplitudeExperiments>
                  </Intercom>
                </TooltipProvider>
              </ToastProvider>
            </AlertProvider>
          </AppSuspense>
        </AppErrorHandler>
      </QueryProvider>
    </AppThemeProvider>
  )
}

const router = createBrowserRouter(routes, { basename: getRouterBasename() })

declare global {
  interface Window {
    /** If specified, it represents the target repository. This is useful for running E2E tests in specific, temporary repositories */
    __repository__?: string
  }
}
